/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveLocationSuccess extends React.Component<*> {
  render(): React.Node {
    const { t, actionDrawerStore, response }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <h3>{t('general:locations.archived')}</h3>
            <p>{t('general:locations.messages.archived')}</p>
            {response.company && (
              <ul>
                <li>
                  <b>{t('general:company')}</b>
                </li>
                <li>{response.company}</li>
              </ul>
            )}
            {response.site && (
              <ul>
                <li>
                  <b>{t('general:locations.labels.site')}</b>
                </li>
                <li>{response.site}</li>
              </ul>
            )}
            {response.building && (
              <ul>
                <li>
                  <b>{t('general:locations.labels.building_transport')}</b>
                </li>
                <li>{response.building}</li>
              </ul>
            )}
            {response.room && (
              <ul>
                <li>
                  <b>{t('general:locations.labels.lab_room')}</b>
                </li>
                <li>{response.room}</li>
              </ul>
            )}
            {response.workspace && (
              <ul>
                <li>
                  <b>{t('general:locations.labels.system_workspace')}</b>
                </li>
                <li>{response.workspace}</li>
              </ul>
            )}
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
